import React from 'react';
import { Row, Typography } from 'antd';
import { withRouter } from 'react-router-dom';
import '../../reconciliation.less';
import '../../../../index.less';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { downloadReconciliationFile } from '../../../../store/actions/reconciliationAction';
import { RootState } from '../../../../store';
import { ApplicationDetailModel } from '../../../../store/models/applicationDetailModel';
import { ReconciliationState } from '../../../../store/models/reconciliationModel';

const DownloadCtxModal = (): any => {
  const dateToday = moment(new Date()).format('DD MMM YYYY');
  const {insurerName, tpaId, centerId : centerID, utrDate, dod, utrNumber, searchKey, viewId} =
  useSelector((state: RootState): ReconciliationState => state.reconciliation || []);
  const appdetails = useSelector((state: RootState): ApplicationDetailModel => state.applicationDetail);
  const dispatch = useDispatch();
  const downloadReport = (): any => {
    const payload = {
      providerId: appdetails.getProviderId(),
      insurerName,
      tpaId,
      centerID,
      utrDate,
      dod,
      utrNumber,
      searchKey,
      filters: [],
      statusFilters: [],
      sortingKey: {},
      startIndex: 0,
      range: 0,
      viewId,
    };
    dispatch(downloadReconciliationFile({payload, url: 'Reconciliation/DownloadReconciliationReport', extension: 'csv'}));
  };
  return (
      <div className="flex flex-element flex-col file-container download-report">
        <div className="flex flex-element flex-row items-center justify-start gap-10">
          <img src={require('../../../../assets/images/svg/csv.svg')} height={'40px'}/>
          <div onClick={downloadReport} className="mouse-pointer">
            <Row>
              <Typography.Text className="report-heading">{viewId === 3 ? 'UTR Report' : 'Reconciliation Report'}</Typography.Text>
            </Row>
            <Row>
              <Typography.Text className="report-date">(Latest - {dateToday})</Typography.Text>
            </Row>
          </div>
        </div>
        <div>
          <div>
            <strong>*Note - </strong>Downloadable Link will also be provided on hospital's configured mailbox.
          </div>
        </div>
      </div>
  );
};

export default withRouter(DownloadCtxModal);
